import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTListItem from "../../_common/ListItem"
import moment from "../../../helpers/moment"

const StudentsList = (props) => {

    const {
        contents,
        onlineCourse
    } = props

    if (!contents)
        return null


    return (
        <div className='mc-ead-students-list'>

            <NRTListItem>
                {
                    onlineCourse &&
                    <span className={'date title'}> Início do Curso</span>
                }
                <span className={'name title'}> Aluno </span>
                {
                    onlineCourse &&
                    <Fragment>
                        <span className={'date title'}> Último Acesso</span>
                        <span className={'name title'}> Último Conteúdo Acessado</span>
                    </Fragment>
                }
            </NRTListItem>

            {
                contents.map(content =>
                    <NRTListItem showOnlySeparatorkey={content.personCode}>
                        {
                            onlineCourse && content.beginCourseDate &&
                            <span className={'date'}>
                                {moment(content.beginCourseDate).format('DD/MM/YYYY HH:mm')}
                            </span>
                        }
                        <span className={'name'}>
                            {content.personName}
                        </span>

                        {
                            onlineCourse && content.lastActionDate &&
                            <span className={'date'}>
                                {moment(content.lastActionDate).format('DD/MM/YYYY HH:mm')}
                            </span>
                        }

                        {
                            onlineCourse && content.lastContent &&
                            <span className={'name'}>
                                <span>{content.lastContent}</span>
                            </span>
                        }
                    </NRTListItem>
                )
            }
        </div>
    )
}

StudentsList.propTypes = {
    contents: PropTypes.arrayOf(
        PropTypes.shape({
            personCode: PropTypes.any,
            personName: PropTypes.string,
            beginCourseDate: PropTypes.object,
            lastActionDate: PropTypes.object,
            lastContent: PropTypes.string,
        })
    ),
    onlineCourse: PropTypes.bool
}

StudentsList.defaultProps = {}

export default StudentsList



// WEBPACK FOOTER //
// ./src/components/_ead/StudentsList/index.js